<template>
  <div>
    <v-dialog v-model="checkoutDialogDialog" persistent max-width="1200">
      <v-card outlined>
        <v-card-title class="flex justify-between">
          <span>
            {{
            isCreate
            ? text.isCreate + text.title
            : isUpdate
            ? text.isUpdate + text.title
            : text.title
            }}
          </span>
          <v-btn color="error" icon @click="onCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-checkout-in overflow-y-auto">
          <checkout1
            v-if="checkoutDialogDialog"
            :contractCheckOutId="contractCheckOutId"
            :method="method"
            :isClearDebt="isClearDebt"
            @onClose="checkoutDialogDialog = false"
            @onSaveSuccess="onSaveSuccess"
            @onUpdateInvoice="onUpdateInvoice"
            @onError="onError"
          ></checkout1>
        </v-card-text>
        <!-- <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="onCancel">
            <v-icon left>mdi-window-close</v-icon>ปิด
          </v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Checkout1 from "./Checkout1.vue";
export default {
  components: { Checkout1 }, /// new name
  name: "CheckoutDialog",
  props: {
    value: Boolean,
    objectId: String,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
    contractCheckOutId: String,
    method: String,
    isClearDebt: Boolean
  },
  computed: {
    checkoutDialogDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    }
  },
  data() {
    return {
      form: {},
      text: {
        title: "",
        isCreate: "",
        isUpdate: ""
      }
    };
  },
  created() {
    this.text.title = this.$t('area.checkout_and_decrease_stall');
    this.text.isCreate = this.$t('action_type.create');
    this.text.isUpdate = this.$t('action_type.edit');
  },
  methods: {
    onError(value) {
      this.$emit("onError", value);
    },
    async initData() {
      try {
        const params = {};
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        const params = this.form;
      } catch (e) {
        console.log(e);
      }
    },
    onSaveSuccess(contractCheckOut) {
      try {
        this.$emit("onSaveSuccess", contractCheckOut);
      } catch (e) {
        console.log(e);
      }
    },
    onUpdateInvoice(contractCheckOut) {
      try {
        this.$emit("onUpdateInvoice", contractCheckOut);
      } catch (e) {
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.checkoutDialogDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-checkout-in.v-card__text::v-deep {
  height: 90vh;
  max-height: calc(90vh - 65px);
}
</style>
